export const styles = {
    loading: {
        "& .svg": {
            width: "36px",
            height: "36px",
        },
        "& .path": {
            fill: "none",
            fillRule: "evenodd",
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 4,
            strokeDasharray: 70,
            strokeDashoffset: 70,
            animation: "draw 750ms ease-in-out alternate infinite",
            "@keyframes draw": {
                "0%": {
                    strokeDashoffset: -60,
                },
                "90%": {
                    strokeDashoffset: 0,
                },
                "100%": {
                    strokeDashoffset: 0,
                },
            },
        },
    },
};
